export const WorkspaceQueryKeys = {
  fetchUserWorkspaces: ['user-workspaces'],
  workspaceWithMembers: (id: number) => ['workspace-with-members', id],
};
